import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	errorMessage: {
		id: 'issue-table.common.fields.error.error-message',
		defaultMessage: 'There was a problem showing this field.',
		description: 'Error message shown to user when field fails to render.',
	},
});
